import { isEmpty, values, has } from 'lodash';

export function isSignedIn(state) {
  return !isEmpty(state.user);
}

export function currentUser(state) {
  return state.user;
}

export function currentUserId(state) {
  if (!state.user) {
    return null;
  }

  return state.user.id;
}

export function currentUserGrade(state) {
  if (!state.user) {
    return null;
  }

  return state.user.grade || 0;
}

export function currentUserRole(state) {
  if (!state.user) {
    return null;
  }

  return state.user.role;
}

export function currentUserName(state, getters) {
  return getters.currentUser.name;
}

export function currentUserCountryCode(state, getters) {
  return getters.currentUser.country_code || 'KR';
}

export function currentUserLanguage(state, getters) {
  return getters.currentUser.language;
}

export function isPrimeSupportCountry(state, getters) {
  return getters.currentUserCountryCode === 'KR';
}

export function isSupportedGrade(state, getters) {
  return getters.currentUserGrade > 2;
}

export function isTeacherUser(state, getters) {
  return getters.currentUserRole === 'teacher';
}

export function isParentUser(state, getters) {
  return getters.currentUserRole === 'parent';
}

export function userRelationships(state) {
  return state.userRelationships;
}

export function userChildrenList(state) {
  return values(state.userRelationships).filter(relation => (
    has(relation, 'child')
  ))
  .map(relation => (relation.child));
}

export function getIsDevice(state) {
  return !isEmpty(state.device);
}

export function isPrime(state) {
  return state.user.is_prime;
}

export function userLicence(state) {
  return state.userLicence;
}

export function isUserLicence(state) {
  if (isEmpty(state.userLicence)) {
    return false;
  }

  return true;
}

export function isPremiumSchool(state) {
  return state.premiumSchool && state.premiumSchool.is_premium_school;
}

export function isSubscriptionUser(state, getters) {
  return getters.isPrime ||
    getters.isUserLicence ||
    getters.isPremiumSchool;
}

export function getGradeMap(state) {
  return state.gradeMap || {};
}

export function getSupportCountries(state) {
  return state.supportCountries;
}



// WEBPACK FOOTER //
// ./src/app/auth/store/getters.js